export enum CronJobStatus {
    DONE    = "DONE",
    RUNNING = "RUNNING",
}
